import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient } from "@tanstack/react-query";
import { routeTree } from "./routeTree.gen";
import { MakoAPIClient } from "@/apiClient";
import type { RouterContext } from "@/routes/__root";
import { getEnv } from "@/utils/env";

import "@/styles/globals.css";
import "@/styles/tooltip.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      throwOnError: true,
    },
  },
});

const api = new MakoAPIClient({
  WITH_CREDENTIALS: true,
  BASE: getEnv().NEXT_PUBLIC_CLIENT_SIDE_API_URL,
});

const router = createRouter({
  routeTree,
  context: { queryClient, api } satisfies RouterContext,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
